import { MerchantType, VerificationStatus, Locales, Role } from "@/enums/enums";
import { UserInfoModel } from "../user/userModel";
import { AddressDetailModel } from "../address/addressModel";

export class MainMerchantModel {
  merchant!: MerchantInfoModel;
  role!: MerchantRoleModel;
}

export class MerchantInfoModel {
  merchantId!: number;
  merchantName!: string;
  merchantNameEng!: string;
  merchantNameTh!: string;
  merchantBranchCode!: string;
  merchantTaxId!: string;
  merchantType!: number;
  taxStatus!: number;
  currentMainPackageId!: number;
  createDateTime!: Date;
  expireDateTime!: Date;
  logoUrl!: string;
  stampUrl!: string;
  status!: number;
  merchantAccountingFirmId!: number;
  lastUpdateDateTime!: Date;
  lastCampaignName!: string;
  lastPromoCode!: string;
  packageName!: string;
  isSample!: boolean;
  isVat!: boolean;
  active!: boolean;
  isDisabled!: boolean;
  isActivePayroll!: boolean;
}

export class MerchantRoleModel {
  isSuperUser!: boolean;
  isUsePayroll!: boolean;
  isUsePeakBoard!: boolean;
  manageFinance!: boolean;
  manageProduct!: boolean;
  manageUser!: boolean;
  role!: Role;
}

export class MerchantModel {
  merchantId!: number;
  merchantName!: string;
  merchantBranchCode!: string;
  merchantTaxId!: string;
  merchantType!: MerchantType;
  logoUrl!: string;
  isUsePassCodeOnPublicLink!: boolean;
  verificationStatus!: VerificationStatus;
  isQrPayment!: boolean;
  isAFP!: boolean;
}
export class MerchantDetail extends AddressDetailModel {
  branchCode!: string;
  email!: string;
  faxNumber!: string;
  isVat!: boolean;
  line!: string;
  merchantId!: number;
  merchantType!: MerchantType;
  name!: string;
  phoneNumber!: string;
  taxNumber!: string;
  user!: UserInfoModel;
  website!: string;
  logoUrl!: string;
  stampUrl!: string;
}
